import React from 'react';
export function IndustriesServed() {
  return <section className="w-full bg-white py-20 px-4" id="industries" aria-label="Industries served" data-id="element-77">
      <div className="max-w-4xl mx-auto text-center" data-id="element-78">
        {/* Heading */}
        <h2 className="font-bold text-4xl" style={{
        color: '#1B2A4A'
      }} data-id="element-79">
          Industries We Serve
        </h2>

        {/* Pills */}
        <div className="flex flex-wrap justify-center gap-3 mt-10 mb-8" data-id="element-80">
          <span className="rounded-full px-6 py-2 text-sm font-medium border" style={{
          backgroundColor: '#E8F6F5',
          color: '#2DA5A0',
          borderColor: '#b2e0de'
        }} data-id="element-81">
            Legal
          </span>
          <span className="rounded-full px-6 py-2 text-sm font-medium border" style={{
          backgroundColor: '#E8F6F5',
          color: '#2DA5A0',
          borderColor: '#b2e0de'
        }} data-id="element-82">
            Medical &amp; Healthcare
          </span>
          <span className="rounded-full px-6 py-2 text-sm font-medium border" style={{
          backgroundColor: '#E8F6F5',
          color: '#2DA5A0',
          borderColor: '#b2e0de'
        }} data-id="element-83">
            Corporate
          </span>
          <span className="rounded-full px-6 py-2 text-sm font-medium border" style={{
          backgroundColor: '#E8F6F5',
          color: '#2DA5A0',
          borderColor: '#b2e0de'
        }} data-id="element-84">
            Government
          </span>
          <span className="rounded-full px-6 py-2 text-sm font-medium border" style={{
          backgroundColor: '#E8F6F5',
          color: '#2DA5A0',
          borderColor: '#b2e0de'
        }} data-id="element-85">
            Academic &amp; Research
          </span>
          <span className="rounded-full px-6 py-2 text-sm font-medium border" style={{
          backgroundColor: '#E8F6F5',
          color: '#2DA5A0',
          borderColor: '#b2e0de'
        }} data-id="element-86">
            Media &amp; Entertainment
          </span>
        </div>

        {/* Subtext */}
        <p className="text-gray-500 text-sm" data-id="element-87">
          Our professionals are subject-matter experts with deep industry
          knowledge.
        </p>
      </div>
    </section>;
}